import React from 'react';
import FormsySimpleInput from './FormsySimpleInput';

class InputAutoComplete extends React.Component {
  state = {
    value: '',
    selectedItem: {},
    availableItems: [],
    matches: []
  };

  render = () => {
    //todo: performance enhancements
    const { handleChange, renderMatches, handleBlur, updateMatches } = this;
    const { value } = this.state;
    const { name, placeholder, type, autoComplete, required } = this.props;
    const inputProps = {
      type,
      name,
      placeholder,
      value,
      autoComplete,
      required,
      onChange: handleChange,
      onBlur: handleBlur,
      onFocus: e => updateMatches(e.target.value)
    };
    return (
      <div className="simple-input--auto-complete">
        <FormsySimpleInput {...inputProps} />
        {renderMatches()}
      </div>
    );
  };

  renderMatches = () => {
    const { matches } = this.state;
    const { itemProp } = this.props;
    if (matches.length > 0)
      return (
        <div className="simple-input__matches">
          <ul>
            {matches.map(match => (
              <li
                key={match.id}
                className="simple-input__match"
                onMouseDown={() => this.selectItem(match)}
              >
                <p className="p">{match[itemProp]}</p>
              </li>
            ))}
          </ul>
        </div>
      );
  };

  selectItem = selectedItem => {
    const { itemProp, onChange, name } = this.props;
    this.setState({
      selectedItem,
      value: selectedItem[itemProp],
      matches: []
    });
    onChange(name, selectedItem);
  };

  filterItems = value => {
    // if there's no value we're done here.
    if (!value) return [];

    const { availableItems } = this.state;
    const { itemProp } = this.props;
    const part = value.toLowerCase();

    return availableItems.filter(item =>
      item[itemProp].toLowerCase().includes(part)
    );
  };

  handleChange = e => {
    const { value } = e.target;
    const { onChange, name } = this.props;
    const selectedItem = this.updateMatches(value);
    onChange(name, selectedItem);
  };

  updateMatches = value => {
    const matches = this.filterItems(value);
    const { itemProp } = this.props;

    let selectedItem = {};
    if (
      matches.length === 1 &&
      matches[0][itemProp].toLowerCase() === value.toLowerCase()
    )
      selectedItem = matches[0];
    else selectedItem = { [itemProp]: value };

    this.setState({ value, matches, selectedItem });
    return selectedItem;
  };

  handleBlur = e => {
    this.setState({ matches: [] });
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      value:
        nextProps.value === null
          ? ''
          : nextProps.value[nextProps.itemProp] || '',
      selectedItem: { ...nextProps.value },
      availableItems: [...nextProps.availableItems] || []
    };
  }

  static defaultProps = {
    value: {}
  };
}

export default InputAutoComplete;



// WEBPACK FOOTER //
// ./src/components/form/InputAutoComplete.js